import {useTranslation} from 'react-i18next';

import ArchiveIcon from '@mui/icons-material/Archive';
import {Icon} from '@mui/material';

import {EmpionTooltip} from '../EmpionTooltip/EmpionTooltip';

import {ReactComponent as Valid} from '../../assets/job_postings/icons/valid.svg';
import {JobPosting} from '../../features/company/recruiting/job-postings/types/JobPostingsTypes';
import {greenColors} from '../../layouts/theme/designSystem';

interface Props {
  jobPosting: JobPosting;
  color?: string;
}
export const JobPostingStatus = ({jobPosting, color}: Props) => {
  const {t} = useTranslation();
  const textColor = color ? color : greenColors[100];

  if (jobPosting.archivedAt) {
    return (
      <EmpionTooltip title={t('shared.archived')} isEnabled>
        <Icon
          sx={{
            marginLeft: {xs: '0px', sm: '3px'},
          }}
          fontSize='small'
        >
          <ArchiveIcon
            sx={{
              color: textColor,
            }}
          />
        </Icon>
      </EmpionTooltip>
    );
  } else if (jobPosting.publishedAt) {
    return (
      <EmpionTooltip title={t('shared.published')} isEnabled>
        <Valid fill={textColor} />
      </EmpionTooltip>
    );
  } else {
    return null;
  }
};
